export const SEARCH_FETCH = "SEARCH_FETCH";
export const SEARCH_FETCH_SUCCESS = "SEARCH_FETCH_SUCCESS";
export const SEARCH_FETCH_NEXT = "SEARCH_FETCH_NEXT";
export const SEARCH_FETCH_NEXT_SUCCESS = "SEARCH_FETCH_NEXT_SUCCESS";
export const SEARCH_RESET = "SEARCH_RESET";
export const SET_SEARCH_CONFIG = "SET_SEARCH_CONFIG";
